import React from 'react';
import {connect} from "react-redux";
import {Col, Form, FormGroup, Modal, Row} from "react-bootstrap";
import { Formik, Field } from 'formik';
import {SUPPORT_MODAL_HIDE_REFUND_SALAD, validateRefundSalad} from "../actions";
import {rd} from "../../../utils";
import {getRefundProductSubTypeList} from "../../../selectors/refund_modal";


class InternalRefundSaladModal extends React.Component {

  render() {
    const {sub_type_list, modal, hide, validate} = this.props;

    const minQuantity = modal.minQuantity || 1;
    const maxQuantity = modal.maxQuantity || 0;
    const defaultQuantity = maxQuantity;
    const pricePerUnitQuantity = modal.totalPrice ? modal.totalPrice / modal.quantityBought : 0;

    return <Modal
      show={modal && modal.show}
      animation={false}
      backdrop={true}
      onHide={function() { hide(); }}
      keyboard={true}
      className="RefundSaladModal"
    >
      <Modal.Body>
        <h4>{modal.label}</h4>
        {modal.alertWarning &&
          <div className="alert alert-warning" role="alert"><b>{modal.alertWarning}</b></div>
        }
        {modal.alertInfo &&
          <div className="alert alert-info" role="alert">{modal.alertInfo}</div>
        }
        
        <Formik
          initialValues={{
            quantity : defaultQuantity,
            pricePerUnitQuantity : pricePerUnitQuantity,
            sub_type_list: sub_type_list,
            minQuantity: minQuantity,
            maxQuantity: maxQuantity,
            subtype: ''
          }}
          onSubmit={function(values) {
            validate(values.quantity, values.notes, modal);
          }}
          render={function(props) {
            const values = props.values;

            return <form onSubmit={props.handleSubmit} className="form-horizontal">
              <FormGroup as={Row} controlId="formHorizontalEmail">
                <Col as={Form.Label} sm={4}>
                  Quantité à rembourser
                </Col>
                <Col sm={8}>
                  <Field type="number" name="quantity" placeholder="Quantité à rembourser" className="form-control"
                         required autoFocus={true}
                         onChange={function(e) {
                          let qty = e.target.value;
                          if (qty < values.minQuantity)
                            qty = values.minQuantity;
                          else if (qty > values.maxQuantity)
                            qty = values.maxQuantity;
                          props.setFieldValue("quantity", qty);
                        }} />
                </Col>
              </FormGroup>
              <FormGroup as={Row} controlId="formControlsSelect">
                <Col as={Form.Label} sm={4}>
                  Type de raison
                </Col>
                <Col sm={8}>
                  <Field
                    name="subtype"
                    className="form-control"
                    required="required"
                    component="select"
                  >
                    <option value="">choisir</option>
                    {values.sub_type_list.map(function(e) { return (<option key={e.subtype} value={e.subtype}>{e.label}</option>); })}
                  </Field>
                </Col>
              </FormGroup>
              <FormGroup as={Row} controlId="formControlsSelect">
                <Col as={Form.Label} sm={4}>
                  Explications
                </Col>
                <Col sm={8}>
                  <Field
                    name="notes"
                    className="form-control"
                    component="textarea"
                  />
                </Col>
              </FormGroup>
              <FormGroup as={Row}>
                <Col sm={12} className="offset-sm-5">
                  <button type="submit"
                          className="btn btn-primary">Rembourser {rd(values.pricePerUnitQuantity * values.quantity)} €
                  </button>
                </Col>
              </FormGroup>
            </form>;
          }}
        />
      </Modal.Body>
    </Modal>;

  }
}

export const RefundSaladModal = connect(
  function(state) {
    return {
      "modal" : state.support.modalRefundSalad,
      "sub_type_list": getRefundProductSubTypeList(state),
    };
  },
  function(dispatch) {
    return {
      "hide": function() {
        dispatch({"type": SUPPORT_MODAL_HIDE_REFUND_SALAD});
      },
      "validate": function(quantity, notes, modal) {
        dispatch({'type': SUPPORT_MODAL_HIDE_REFUND_SALAD});
        dispatch(validateRefundSalad(
          quantity,
          notes || '',
          modal
        ));
      }
    };
  }
)(InternalRefundSaladModal);
